import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import {setLocationHref, setURLParams} from 'BenchlingUtil';
import {getActiveShareLinkShareId} from 'ShareAccess';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export default function EditNowButton(): JSX.Element {
  return (
    <Tooltip title="Ready to edit? Just sign in or create an account." placement={TooltipPlacement.BOTTOM}>
      <Button
        className={css(styles.shareLinkEditButton)}
        size={ButtonSize.SMALL}
        buttonStyle={ButtonStyle.SECONDARY}
        onClick={() => {
          analytics.track('benchling', 'initiated_signup', {
            signup_source: 'signed out view',
            source_component: 'EditNowButton',
          });
          setLocationHref(
            setURLParams('/signup', {
              shareIdToClone: getActiveShareLinkShareId(),
              // The next param will only apply to users who sign *in* to an existing account: they will not
              // get a clone of the shared sequence, but should be redirected to it after login
              next: window.location.href,
            })
          );
        }}
      >
        Edit now
      </Button>
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  shareLinkEditButton: {
    margin: '5px 10px 5px 5px',
  },
});
